"use client";

import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing16, spacing32 } from "@churchofjesuschrist/eden-style-constants";
import { ReadWidth } from "@churchofjesuschrist/eden-content-widths";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { jsx as _jsx } from "react/jsx-runtime";
const transitionTime = 400;
const Animator = styled.div.withConfig({
  componentId: "sc-4iil14-0"
})(["position:sticky;display:flex;height:0;width:100%;justify-content:center;top:", ";right:0;pointer-events:", ";transition:", "ms ease-out;opacity:", ";transform:", ";", ""], spacing16, ({
  open
}) => open ? "auto" : "none", transitionTime, ({
  open
}) => open ? "1.0" : "0.0", ({
  open
}) => open ? `translate3d(0, 0, 0)` : `translate3d(calc(${spacing32}), 0, 0)`, mediaBreak600w`
    justify-content: flex-end;
  `);

/** A wrapper which animates in an alert notification and is fixed to its closest scrollable parent */
const Overlay = ({
  children,
  open,
  ...rest
}) => {
  const overlayRef = useRef();
  useEffect(() => {
    open && overlayRef.current.focus();
  }, [open]);
  return /*#__PURE__*/_jsx(Animator, {
    open: open,
    ...rest,
    role: open ? `alertdialog` : undefined,
    ref: overlayRef,
    tabIndex: open ? 0 : undefined,
    children: /*#__PURE__*/_jsx(ReadWidth, {
      children: children
    })
  });
};
Overlay.displayName = "Overlay";
Overlay.propTypes = {
  /** Must be a single `<Alert>`, `<Error>`, `<Info>`, `<Success>`, or `<Warn>` element from `eden-alert` to display in the overlay. */
  children: PropTypes.node.isRequired,
  /** Controls the visibility of the overlay */
  open: PropTypes.bool
};
export default Overlay;